var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThunder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 92,
    viewBox: "0 0 89 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.4615 10.2222C65.884 10.2222 63.3235 10.7265 60.9068 11.6942C56.2206 4.49437 48.1011 0 39.3654 0C28.2917 0 18.6797 6.93067 15.1334 17.1495C6.62708 18.1308 0 25.3477 0 34.0741C0 43.4683 7.67796 51.1111 17.1154 51.1111H27.3846L23.9615 57.9259L34.2308 68.1481L30.8077 92L54.7692 68.1481L47.9231 57.9259L54.7692 51.1111H68.4615C79.7885 51.1111 89 41.9418 89 30.6667C89 19.3916 79.7885 10.2222 68.4615 10.2222ZM45.9582 67.2793L40.4882 72.7243L41.4911 65.7391L32.2899 56.58L35.0386 51.1111H45.0853L39.1121 57.057L45.9582 67.2793ZM68.4615 44.2963H17.1154C11.4536 44.2963 6.84615 39.7099 6.84615 34.0741C6.84615 28.4382 11.4536 23.8519 16.9648 23.8484L20.4084 24.0256L21.0519 21.2793C23.051 12.7641 30.5818 6.81482 39.3654 6.81482C46.6326 6.81482 53.3247 11.0673 56.4089 17.647L58.0383 21.1157L61.3107 19.1053C63.5426 17.7321 65.949 17.037 68.4615 17.037C76.0128 17.037 82.1538 23.1499 82.1538 30.6667C82.1538 38.1834 76.0128 44.2963 68.4615 44.2963Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThunder);
export default __webpack_public_path__ + "static/media/thunder.c2c2a4795bf7906c5658fff1300fbc01.svg";
export { ForwardRef as ReactComponent };